"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _attributeSelector = _interopRequireDefault(require("@cimpress-technology/attribute-selector"));

var _lodash = require("lodash");

var _V2Parser = require("./V2Parser");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var CompetitorProductsAggregator =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(CompetitorProductsAggregator, _PureComponent);

  var _super = _createSuper(CompetitorProductsAggregator);

  function CompetitorProductsAggregator() {
    var _this;

    (0, _classCallCheck2["default"])(this, CompetitorProductsAggregator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      initialAttributeConfigurations: {}
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidMount", function () {
      var initialAttributeConfigurations = (0, _V2Parser.convertInitialSelections)(_this.props.initialCompetitiveAttributeSelections);

      _this.setState({
        initialAttributeConfigurations: initialAttributeConfigurations
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidUpdate", function (prevProps) {
      if (!(0, _lodash.isEqual)(prevProps.initialCompetitiveAttributeSelections, _this.props.initialCompetitiveAttributeSelections)) {
        var initialAttributeConfigurations = (0, _V2Parser.convertInitialSelections)(_this.props.initialCompetitiveAttributeSelections);

        _this.setState({
          initialAttributeConfigurations: initialAttributeConfigurations
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCompatitorProductsAttributeSelectors", function () {
      var _this$props = _this.props,
          competitorProductsRuleSet = _this$props.competitorProductsRuleSet,
          authToken = _this$props.authToken;
      var initialAttributeConfigurations = _this.state.initialAttributeConfigurations;
      return (
        /*#__PURE__*/
        _react["default"].createElement(_attributeSelector["default"], {
          ruleSet: competitorProductsRuleSet,
          authToken: authToken,
          onChange: _this.props.onChange,
          showErrorAlert: true,
          attributeConfigurations: initialAttributeConfigurations
          /* onReset={() => this.props.onReset}
          onError={this.props.onError} */

        })
      );
    });
    return _this;
  }

  (0, _createClass2["default"])(CompetitorProductsAggregator, [{
    key: "render",
    value: function render() {
      return this.getCompatitorProductsAttributeSelectors();
    }
  }]);
  return CompetitorProductsAggregator;
}(_react.PureComponent);

exports["default"] = CompetitorProductsAggregator;
(0, _defineProperty2["default"])(CompetitorProductsAggregator, "propTypes", {
  competitorProductsRuleSet: _propTypes["default"].shape({}).isRequired,
  authToken: _propTypes["default"].string.isRequired,
  attributeConfigurations: _propTypes["default"].shape({}),
  initialCompetitiveAttributeSelections: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  onReset: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onError: _propTypes["default"].func
});
(0, _defineProperty2["default"])(CompetitorProductsAggregator, "defaultProps", {
  onReset: function onReset() {},
  onChange: function onChange() {},
  attributeConfigurations: {},
  initialCompetitiveAttributeSelections: [],
  onError: function onError() {}
});